import { AxiosResponse } from 'axios'
import get from 'lodash/get'
import { IFilter, Where } from 'types/common'
import { api } from 'API'
import { EOrganizationType } from 'constants/organization-type'
import { IOrganization } from 'interfaces/organization'

export interface ICreateTeamPayload {
  name: string
  // A team can list multiple sports. The quick "Create Team" modal submits only
  // name + sports; the full team form additionally supplies the fields below.
  sports: string[]
  // Required by POST /organizations — every new Organization declares its type.
  organizationType: EOrganizationType
  season?: string
  year?: number
  ageLevel?: string
  description?: string
  primaryLocation?: string
  logo?: string
  // Legacy combined "Spring 2026" field — kept optional during the transition
  // to the separate season/year selects; ignored by the new BE create path.
  seasonYear?: string
}

/**
 * POST /organizations — creates a whole Organization (the API spins up its first
 * Team from the same season fields). Named for what it does: `createTeam` in
 * `API/team` is the one that adds a Team to the organization you are already in.
 */
export async function createOrganization(payload: ICreateTeamPayload): Promise<IOrganization> {
  const res: AxiosResponse = await api.post(`/organizations`, payload)
  return res.data
}

export async function getOrganizations(filter: IFilter<IOrganization> = {}): Promise<IOrganization[]> {
  const organizations: AxiosResponse = await api.get(`/organizations?filter=${JSON.stringify(filter)}`)
  return organizations.data
}

export async function countOrganizations(where: Where<IOrganization> = {}): Promise<number> {
  const organization: AxiosResponse = await api.get(`/organizations/count?where=${JSON.stringify(where)}`)
  return get(organization, 'data.count', 0)
}

export async function updateOrganizationById(organizationId: number, data: Partial<IOrganization>): Promise<void> {
  await api.patch(`/organizations/${organizationId}`, data)
}

export async function getOrganizationById(
  organizationId: string,
  filter: IFilter<IOrganization> = {}
): Promise<IOrganization> {
  const organization: AxiosResponse = await api.get(`/organizations/${organizationId}?filter=${JSON.stringify(filter)}`)
  return organization.data
}
